export var DragSourceTypes = /*#__PURE__*/function (DragSourceTypes) {
  DragSourceTypes["COMPONENT"] = "component";
  DragSourceTypes["NODE"] = "node";
  return DragSourceTypes;
}({});